import style from "./standardPageHeader.module.scss";

export default function HeaderIcon({
  className,
  children,
  text,
  onClick,
  activeMenu,
  isLoading,
  showNotification,
  menuTrigger,
}: HeaderIconProps) {
  // while the header icon info is loading, save the space for the icon to prevent layout shift
  if (isLoading) {
    return <div className={style.headerIconContainer} />;
  }
  return (
    <div
      data-menu-trigger={menuTrigger}
      onClick={onClick}
      className={`${className} ${style.headerIconContainer} ${activeMenu ? style.activeMenu : ""} ${showNotification ? style.withNotification : ""}`}
    >
      {activeMenu && <div className={style.openMenuBuffer} />}
      <div className={style.headerIconWrapper}>
        {children}
        {showNotification && <span className={style.notificationBadge} aria-label="Chat available" />}
      </div>
      <span className={style.headerIconText}>{text}</span>
    </div>
  );
}

export type HeaderIconProps = {
  className: string;
  children: React.ReactNode;
  text: string;
  onClick: () => void;
  activeMenu: boolean;
  isLoading?: boolean;
  showNotification?: boolean;
  /** Value for data-menu-trigger (e.g. "account", "support"); used so only non-active triggers are ignored by outside-click. */
  menuTrigger?: string;
};
